// src/App.js
import { Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Programs from './components/Programs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import HowItWorks from './components/HowItWorks';
import WhyChooseUs from './components/WhyChooseUs';

import LifeguardClasses from './pages/LifeguardClasses';
import SwimInstructor from './pages/SwimInstructor';
import LifesavingInstructor from './pages/LifesavingInstructor';
import SwimLessons from './pages/SwimLessons';
import Register from './pages/Register';

import Lifeguarding from './pages/Lifeguarding';
import FirstAid from './pages/FirstAid';
import Instructor from './pages/Instructor';
import Recertifications from './pages/Recertifications';
import { Analytics } from "@vercel/analytics/react"
function App() {
  return (
    <div className="font-sans text-gray-900">
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Programs />
              <HowItWorks />
              <WhyChooseUs />
              <Contact />
            </>
          }
        />
        <Route path="/lifeguarding" element={<Lifeguarding />} />
        <Route path="/first-aid" element={<FirstAid />} />
        <Route path="/instructor" element={<Instructor />} />
        <Route path="/recertifications" element={<Recertifications />} />
        <Route path="/programs/lifeguard-classes" element={<LifeguardClasses />} />
        <Route path="/programs/swim-instructor" element={<SwimInstructor />} />
        <Route path="/programs/lifesaving-instructor" element={<LifesavingInstructor />} />
        <Route path="/programs/swim-lessons" element={<SwimLessons />} />
       <Route path="/register" element={<Register />} />

      </Routes>
      <Footer />
      <Analytics />
    </div>
  );
}

export default App;
